// extracted by mini-css-extract-plugin
var _1 = "RequestTag-moduleRequestTag__INw7t Tag-moduleTag__FLr9H";
export { _1 as "RequestTag" }
